import { Collapse } from 'antd';
import styled from 'styled-components';

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-content-box {
    padding: 8px 20px 20px 20px;
  }
`;
